@if ({ isLoading: isLoading$ | async, sites: sites$ | async, isMobile: isMobile$
| async, multiSiteSupport: multiSiteSupport$ | async, isInSiteSelector:
isInSiteSelector$ | async, openSiteSelectorManually: openSiteSelectorManually$ |
async }; as ctx) {
<nav class="navbar border-bottom p-0 pr-3">
  @if (ctx.isLoading) {
  <a class="navbar-brand" [routerLink]="['/']" data-e2e="tenant-logo"
    ><img src="static/images/logo.svg" alt="" height="16"
  /></a>
  } @if (!ctx.isLoading) {
  <epc-brand-org-site
    [sites]="ctx.sites"
    (selectSite)="onSelectSite($event)"
    [openSelectorOnStart]="ctx.isMobile || ctx.isInSiteSelector"
    [openSelectorManually]="ctx.openSiteSelectorManually"
    [multiSiteSupport]="ctx.multiSiteSupport"
    [isMobile]="ctx.isMobile"
  ></epc-brand-org-site>
  }
  <atx-image
    class="main-icon d-none d-md-block"
    data-e2e="site-selector-main-image"
    [imageUrl]="'static/images/site-selector-logo.png'"
    [maxWidth]="imageMaxSizes.THUMBNAIL"
    failedLoadIconSize="1x"
  ></atx-image>
  <ul class="navbar-nav">
    <li class="nav-item" data-e2e="user">
      <epc-user-menu-widget></epc-user-menu-widget>
    </li>
  </ul>
</nav>
} @if ((isLoading$ | async) === false) {
<div class="background-image justify-content-center">
  <atx-image
    data-e2e="site-selector-main-image"
    [imageUrl]="background$ | async"
    failedLoadIconSize="1x"
    objectFit="cover"
  ></atx-image>
</div>
} @else {
<atx-loader-overlay></atx-loader-overlay>
}
